export default __webpack_public_path__ + "static/media/CONTRATO-PLAN-VIRTUAL-v3.9f8015a3.pdf";